<template>
  <div class="p-2">
    <!-- Signature Provider -->
    <div class="flex pt-3 pb-6 gap-3">
      <!-- HODO -->
      <div class="flex flex-col bg-white rounded-2xl shadow p-6 hover:shadow-lg transition-all border w-full">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center">
            <div class="text-3xl mr-3">
              <svg class="mr-1" width="40" height="40" viewBox="0 0 32 33" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.91091 30.1988L2.52089 22.8088C-0.840297 19.4476 -0.840297 13.9951 2.52089 10.6306L9.91091 3.24062C13.2721 -0.12057 18.7246 -0.12057 22.0891 3.24062L29.4791 10.6306C32.8403 13.9918 32.8403 19.4444 29.4791 22.8088L22.0891 30.1988C18.7246 33.56 13.2754 33.56 9.91091 30.1988Z"
                  fill="#20409B" />
                <path
                  d="M16.1889 10.7322C16.4802 10.706 16.7584 10.6537 17.0136 10.5719C17.4686 10.4475 17.8678 10.2249 18.1951 9.93038C18.2409 9.89111 18.2868 9.84529 18.3326 9.80274L18.349 9.78638C18.9512 9.18418 19.2817 8.33325 19.2326 7.3514C19.1966 6.61174 18.9282 5.95391 18.4995 5.44335C18.3817 5.29935 18.2508 5.16843 18.1068 5.05061C17.5929 4.6186 16.9351 4.3535 16.1954 4.31422C15.2594 4.2684 14.451 4.56296 13.8554 5.10952C13.8226 5.13897 13.7932 5.16516 13.7637 5.19461C13.3874 5.5579 13.1092 6.02264 12.9652 6.56593C12.9619 6.58229 12.9553 6.59865 12.9521 6.61502C12.8866 6.84739 12.8408 7.09612 12.8179 7.35468C12.8179 7.3874 12.8113 7.42013 12.8081 7.44958C12.4579 11.1806 10.5433 13.1247 6.84499 13.5076C6.7959 13.5141 6.74681 13.5174 6.69772 13.5239C4.81912 13.6941 3.5918 14.9672 3.60162 16.7378C3.60817 17.6542 3.95508 18.4397 4.55074 19.0059C5.11694 19.6016 5.90242 19.9452 6.81553 19.9518C8.58613 19.9648 9.85926 18.7375 10.0294 16.8557C10.0327 16.8033 10.0393 16.7575 10.0458 16.7084C10.4255 13.0068 12.3728 11.0922 16.1038 10.742C16.1267 10.7388 16.1594 10.7355 16.1889 10.7322Z"
                  fill="white" />
                <path
                  d="M25.3608 19.906C25.6521 19.8799 25.9302 19.8275 26.1855 19.7457C26.6404 19.6213 27.0397 19.3988 27.367 19.1042C27.4128 19.0649 27.4586 19.0191 27.5045 18.9766L27.5208 18.9602C28.123 18.358 28.4536 17.5071 28.4045 16.5252C28.3685 15.7856 28.1001 15.1277 27.6714 14.6172C27.5536 14.4732 27.4226 14.3423 27.2786 14.2244C26.7648 13.7924 26.107 13.5273 25.3673 13.4881C24.4313 13.4422 23.6229 13.7368 23.0273 14.2833C22.9945 14.3128 22.9651 14.339 22.9356 14.3684C22.5592 14.7317 22.281 15.1965 22.137 15.7398C22.1338 15.7561 22.1272 15.7725 22.1239 15.7888C22.0585 16.0212 22.0127 16.2699 21.9898 16.5285C21.9898 16.5612 21.9832 16.594 21.9799 16.6234C21.6298 20.3544 19.7152 22.2985 16.0169 22.6814C15.9678 22.6879 15.9187 22.6912 15.8696 22.6978C13.991 22.868 12.7637 24.1411 12.7735 25.9117C12.78 26.8281 13.127 27.6135 13.7226 28.1797C14.2888 28.7754 15.0743 29.119 15.9874 29.1256C17.758 29.1387 19.0311 27.9114 19.2013 26.0295C19.2046 25.9771 19.2111 25.9313 19.2177 25.8822C19.5973 22.1807 21.5447 20.2661 25.2757 19.9159C25.2986 19.9126 25.328 19.9093 25.3608 19.906Z"
                  fill="white" />
                <path
                  d="M16.0116 19.9489C17.801 19.9489 19.2517 18.4983 19.2517 16.7088C19.2517 14.9194 17.801 13.4688 16.0116 13.4688C14.2221 13.4688 12.7715 14.9194 12.7715 16.7088C12.7715 18.4983 14.2221 19.9489 16.0116 19.9489Z"
                  fill="white" />
              </svg>
            </div>
            <h2 class="text-xl font-semibold mb-0">HODO Smart Sign</h2>
          </div>
          <div v-if="hodoSign && hodoSign.value == 'true' && hodoSign.status == 0"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đã tiếp nhận</span>
          </div>
          <div v-if="hodoSign && hodoSign.value == 'true' && hodoSign.status == 2"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang xử lý</span>
          </div>
          <div v-if="hodoSign && hodoSign.value == 'true' && hodoSign.status == 1"
            class="inline-block bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang hoạt động</span>
          </div>
          <div v-if="hodoSign && hodoSign.value == 'true' && hodoSign.status == 3"
            class="inline-block bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Từ chối</span>
          </div>
        </div>
        <ul class="text-gray-600 mb-6 space-y-2 text-sm list-none pl-[45px]">
          <li>✔ Ký trực tiếp trên trình duyệt</li>
          <li>✔ Không cần thiết bị USB Token</li>
          <li>✔ Không cần xác thực</li>
          <li>✔ Phù hợp với cơ quan quản lý nội bộ</li>
        </ul>
        <div class="mt-auto">
          <button v-if="!hodoSign" @click="registerSignature('hodo_sign')" type="button"
            class="w-full flex items-center justify-center border-0 focus:outline-none bg-blue-700 hover:bg-blue-800 text-white transition-all duration-200 rounded-lg h-9 px-3 py-2 text-base font-semibold">
            <span>Đăng ký sử dụng HODO Sign</span>
          </button>
        </div>
        <!--  -->
        <div v-if="hodoSign && hodoSign.value == 'true' && (hodoSign.status == 0 || hodoSign.status == 2)">
          <p class="mb-1"><span class="font-semibold">Thời gian gửi yêu cầu:</span> {{
            formatDateDMY(hodoSign.created_at) }}</p>
          <p class="mb-0 text-xs italic text-yellow-800">Yêu cầu của bạn đã được tiếp nhận và đang được xử lý. Quá trình
            này có thể mất khoảng 1-2 <strong>ngày</strong> làm việc.</p>
        </div>
      </div>
      <!-- VNPT -->
      <div class="flex flex-col bg-white rounded-2xl shadow p-6 hover:shadow-lg transition-all border w-full">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center">
            <div class="text-3xl mr-3">
              <img width="40" height="40" src="@/assets/images/vnptca.svg" alt="">
            </div>
            <h2 class="text-xl font-semibold mb-0">VNPT SmartCA</h2>
          </div>
          <div v-if="vnptSign && vnptSign.value == 'true' && vnptSign.status == 0"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đã tiếp nhận</span>
          </div>
          <div v-if="vnptSign && vnptSign.value == 'true' && vnptSign.status == 2"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang xử lý</span>
          </div>
          <div v-if="vnptSign && vnptSign.value == 'true' && vnptSign.status == 1"
            class="inline-block bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang hoạt động</span>
          </div>
          <div v-if="vnptSign && vnptSign.value == 'true' && vnptSign.status == 3"
            class="inline-block bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Từ chối</span>
          </div>
        </div>
        <ul class="text-gray-600 mb-6 space-y-2 text-sm list-none pl-[45px]">
          <li>✔ Ký số từ xa qua dịch vụ SmartCA của VNPT</li>
          <li>✔ Được VNPT cấp chứng thư hợp lệ</li>
          <li>✔ Phù hợp với ký gửi cơ quan nhà nước</li>
        </ul>
        <button disabled type="button"
          class="mt-auto opacity-65 pointer-events-none w-full flex items-center justify-center border-0 focus:outline-none bg-gray-200 hover:bg-gray-400 text-gray-600 transition-all duration-200 rounded-lg h-9 px-3 py-2 text-base font-semibold">
          <span>Tính năng đang trong giai đoạn phát triển</span>
        </button>
        <!--        <button v-if="!vnptSign" @click="registerSignature('vnpt_smart_ca')" type="button"-->
        <!--          class="mt-auto w-full flex items-center justify-center border-0 focus:outline-none bg-green-600 hover:bg-green-700 text-white transition-all duration-200 rounded-lg h-9 px-3 py-2 text-base font-semibold">-->
        <!--          <span>Đăng ký sử dụng VNPT SmartCA</span>-->
        <!--        </button>-->
        <!--  -->
        <div v-if="vnptSign && vnptSign.value == 'true' && (vnptSign.status == 0 || vnptSign.status == 2)">
          <p class="mb-1"><span class="font-semibold">Thời gian gửi yêu cầu:</span> {{
            formatDateDMY(vnptSign.updated_at) }}</p>
          <p class="mb-0 text-xs italic text-yellow-800">Yêu cầu của bạn đã được tiếp nhận và đang được xử lý. Quá trình
            này có thể mất khoảng 1-2 <strong>tuần</strong> làm việc.</p>
        </div>
      </div>
    </div>
    <div class="flex pt-3 pb-6 gap-3">
      <!-- IntrustCA -->
      <div class="flex flex-col bg-white rounded-2xl shadow p-6 hover:shadow-lg transition-all border w-50">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center">
            <div class="text-3xl mr-3">
              <!-- Logo IntrustCA -->
              <img width="60" src="@/assets/images/logo_intrust.png" alt="">
            </div>
            <h2 class="text-xl font-semibold mb-0">Intrust CA</h2>
          </div>
          <div v-if="intrustSign && intrustSign.value == 'true' && intrustSign.status == 0"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đã tiếp nhận</span>
          </div>
          <div v-if="intrustSign && intrustSign.value == 'true' && intrustSign.status == 2"
            class="inline-block bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang xử lý</span>
          </div>
          <div v-if="intrustSign && intrustSign.value == 'true' && intrustSign.status == 1"
            class="inline-block bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Đang hoạt động</span>
          </div>
          <div v-if="intrustSign && intrustSign.value == 'true' && intrustSign.status == 3"
            class="inline-block bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-full">
            <span>Từ chối</span>
          </div>
        </div>
        <ul class="text-gray-600 mb-6 space-y-2 text-sm list-none pl-[45px]">
          <li>✔ Ký trực tiếp trên trình duyệt</li>
          <li>✔ Ký số từ xa qua dịch vụ Remote Signing của IntrustCA</li>
          <li>✔ Được IntrustCA cấp chứng thư hợp lệ</li>
        </ul>
        <!-- Registration Info Section -->
        <div class="my-1" v-loading="isLoadingRegistration">
          <div v-if="!isLoadingRegistration && intrustCARegistration" class="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg">
            <!-- Header -->
            <div class="flex items-center mb-1 pb-3 border-b border-blue-200">
              <div class="flex items-center">
                <i class="el-icon-info text-blue-600 text-lg mr-2"></i>
                <h3 class="text-base font-semibold text-blue-900 mb-0">Thông tin đăng ký chữ ký số</h3>
              </div>
            </div>

            <!-- Status Badge and Edit Button -->
            <div class="flex justify-between items-center mb-2">
              <div class="flex items-center gap-2">
                <span class="text-sm text-gray-700">Trạng thái:</span>
                <div class="inline-block px-3 py-1 rounded-full text-xs font-semibold" :class="getRegistrationStatusColor(intrustCARegistration.status)">
                  {{ getRegistrationStatusLabel(intrustCARegistration.status) }}
                </div>
              </div>

              <!-- Edit button for PROGRESSING status -->
              <el-button
                v-if="intrustCARegistration.status === 'PROGRESSING'"
                type="primary"
                icon="el-icon-edit"
                size="small"
                @click="editIntrustCACert()"
                plain
              >
                Chỉnh sửa
              </el-button>
            </div>

            <!-- Registration Details Grid -->
            <div class="space-y-2 mb-3">
              <div class="bg-white rounded p-2 border border-blue-100">
                <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">Tên:</span>
                <span class="text-sm font-semibold ml-2">{{ intrustCARegistration.name_KH || '-' }}</span>
              </div>
              <div class="bg-white rounded p-2 border border-blue-100">
                <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">CCCD:</span>
                <span class="text-sm font-semibold ml-2">{{ intrustCARegistration.individual_identifier_code || '-' }}</span>
              </div>
              <div class="bg-white rounded p-2 border border-blue-100">
                <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">Email:</span>
                <span class="text-sm font-semibold ml-2">{{ intrustCARegistration.email_KH || '-' }}</span>
              </div>
              <div class="bg-white rounded p-2 border border-blue-100">
                <div class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">Ngày gửi yêu cầu</div>
                <div class="text-sm font-bold ">{{ formatDateDMY(intrustCARegistration.created_at) }}</div>  
              </div>
            </div>

            <!-- Edit Info Message -->
            <div v-if="intrustCARegistration.status === 'PROGRESSING'" class="bg-blue-100 border border-blue-300 rounded p-3 mb-3">
              <div class="flex gap-2">
                <i class="el-icon-edit text-blue-600 text-base mt-0.5 flex-shrink-0"></i>
                <div>
                  <p class="text-sm text-blue-900 font-medium mb-1">Chỉnh sửa thông tin</p>
                  <p class="text-xs text-blue-800">Bạn có thể chỉnh sửa thông tin đăng ký trong quá trình xử lý. Nhấp vào nút "Chỉnh sửa" phía trên để cập nhật thông tin.</p>
                </div>
              </div>
            </div>

            <!-- Error message for NEED_INFO status -->
            <div v-if="intrustCARegistration.status === 'NEED_INFO'" class="bg-red-50 border-l-4 border-red-500 rounded p-3">
              <div class="flex gap-3">
                <i class="el-icon-warning text-red-600 text-lg flex-shrink-0 mt-0.5"></i>
                <div>
                  <p class="text-sm font-semibold text-red-800 mb-1">Cần bổ sung thông tin</p>
                  <p class="text-xs text-red-700">{{ intrustCARegistration.error_message || 'Vui lòng cập nhật CCCD' }}</p>
                  <el-button
                    type="danger"
                    icon="el-icon-edit"
                    size="small"
                    @click="editIntrustCACert()"
                    plain
                    class="mt-2"
                  >
                    Cập nhật ngay
                  </el-button>
                </div>
              </div>
            </div>

            <!-- Success message for APPROVED status -->
            <div v-if="intrustCARegistration.status === 'APPROVED'" class="bg-green-50 border-l-4 border-green-500 rounded p-3">
              <div class="flex gap-2">
                <i class="el-icon-success text-green-600 text-lg flex-shrink-0 mt-0.5"></i>
                <div>
                  <p class="text-sm font-semibold text-green-800">Đơn đăng ký đã được duyệt thành công</p>
                  <p class="text-xs text-green-700 mt-1">Chứng thư số của bạn sẽ sớm được cấp.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Current Account IntrustCA -->
        <div class="my-2" v-loading="isLoadingCertificates">
          <div v-if="!isLoadingCertificates && currentIntrustCAAccount && currentIntrustCAAccount.length">
            <div v-for="(cert, idx) in currentIntrustCAAccount" :key="idx"
              class="mb-3 p-3 border rounded-md bg-gray-50">
              <div class="flex justify-between">
                <div>
                  <div class="text-xs text-gray-600">Hạn sử dụng</div>
                  <div class="font-medium">{{ formatIntrustDate(cert.cert_valid_to) || cert.cert_valid_to }}</div>

                  <div class="text-xs text-gray-600 mt-2">Trạng thái</div>
                  <div :class="cert.status === 'VALID' ? 'text-green-600 font-medium' : 'text-red-600 font-medium'">{{
                    cert.status }}</div>
                  <div class="mt-2">
                    <el-tag v-if="cert.auth_method === 1" type="" effect="dark">MOBILE</el-tag>
                    <el-tag v-if="cert.auth_method === 2" type="" effect="dark">PIN</el-tag>
                  </div>
                </div>

                <div class="text-right">
                  <div class="text-xs text-gray-600">Thông tin</div>
                  <div class="font-medium mt-2">{{ cert.name || cert.name_display || '-' }}</div>
                  <div class="text-xs text-gray-500 mt-2">Mã số thuế: {{ cert.cert_tax_code || '' }}</div>
                  <div class="text-xs text-gray-500 mt-2">Nhà cung cấp: {{ cert.cert_provider || '' }}</div>
                  <div class="text-xs text-gray-400 mt-2">Serial: {{ cert.cert_serial || '' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="intrustSign && !isLoadingCertificates && currentIntrustCAAccount && currentIntrustCAAccount.length === 0"
            class="text-sm text-gray-500 mb-1">Chưa có chứng thư số cho tài khoản IntrustCA hiện tại.</div>
        </div>
        <div class="mt-auto">
          <!-- v-if="!intrustSign" -->
          <button v-if="!intrustSign" @click="registerIntrustCACert()" type="button"
            :disabled="intrustCARegistration !== null"
            :class="intrustCARegistration ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-700 hover:bg-green-800'"
            class="w-full flex items-center justify-center border-0 focus:outline-none text-white transition-all duration-200 rounded-lg h-9 px-3 py-2 mb-2 text-base font-semibold">
            <span>Đăng ký chữ ký số IntrustCA</span>
          </button>
          <button v-if="intrustSign" @click="unlinkIntrustCA()" type="button"
            class="w-full flex items-center justify-center border-0 focus:outline-none bg-red-700 hover:bg-red-800 text-white transition-all duration-200 rounded-lg h-9 px-3 py-2 text-base font-semibold mt-2">
            <span>Gỡ liên kết tài khoản</span>
          </button>
          <button v-else @click="loginIntrustCASignature()" type="button"
            class="w-full flex items-center justify-center border-0 focus:outline-none bg-blue-700 hover:bg-blue-800 text-white transition-all duration-200 rounded-lg h-9 px-3 py-2 text-base font-semibold">
            <span>Đăng nhập để sử dụng IntrustCA</span>
          </button>
        </div>
        <!--  -->
        <div v-if="hodoSign && hodoSign.value == 'true' && (hodoSign.status == 0 || hodoSign.status == 2)">
          <p class="mb-1"><span class="font-semibold">Thời gian gửi yêu cầu:</span> {{
            formatDateDMY(hodoSign.created_at) }}</p>
          <p class="mb-0 text-xs italic text-yellow-800">Yêu cầu của bạn đã được tiếp nhận và đang được xử lý. Quá trình
            này có thể mất khoảng 1-2 <strong>ngày</strong> làm việc.</p>
        </div>
      </div>
    </div>
    <!-- Signature List -->
    <div
      v-if="(hodoSign && hodoSign.value == 'true' && hodoSign.status == 1) || (vnptSign && vnptSign.value == 'true' && vnptSign.status == 1) || (intrustSign && intrustSign.value == 'true' && intrustSign.status == 1)">
      <div class="mb-2 fs-20">{{ $t("Danh sách chữ ký") }}</div>
      <div v-loading="isLoading" class="cs-list">
        <div @click="openModalCreateSignature" class="cs-image-container cs-create-signature">
          <div class="flex items-center justify-center flex-col">
            <svg width="48" height="48" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16 3.5C13.5277 3.5 11.111 4.23311 9.05538 5.60663C6.99976 6.98015 5.39761 8.93238 4.45151 11.2165C3.50542 13.5005 3.25787 16.0139 3.74019 18.4386C4.2225 20.8634 5.41301 23.0907 7.16117 24.8388C8.90933 26.587 11.1366 27.7775 13.5614 28.2598C15.9861 28.7421 18.4995 28.4946 20.7835 27.5485C23.0676 26.6024 25.0199 25.0002 26.3934 22.9446C27.7669 20.889 28.5 18.4723 28.5 16C28.4964 12.6859 27.1782 9.5086 24.8348 7.16518C22.4914 4.82177 19.3141 3.50364 16 3.5ZM16 27.5C13.7255 27.5 11.5021 26.8255 9.61095 25.5619C7.71978 24.2983 6.2458 22.5022 5.37539 20.4009C4.50498 18.2995 4.27724 15.9872 4.72097 13.7565C5.1647 11.5257 6.25997 9.47658 7.86828 7.86827C9.47658 6.25997 11.5257 5.1647 13.7565 4.72097C15.9872 4.27724 18.2995 4.50498 20.4009 5.37539C22.5022 6.24579 24.2983 7.71978 25.5619 9.61094C26.8255 11.5021 27.5 13.7255 27.5 16C27.4967 19.049 26.284 21.9721 24.1281 24.1281C21.9721 26.284 19.049 27.4967 16 27.5ZM21.5 16C21.5 16.1326 21.4473 16.2598 21.3536 16.3536C21.2598 16.4473 21.1326 16.5 21 16.5H16.5V21C16.5 21.1326 16.4473 21.2598 16.3536 21.3536C16.2598 21.4473 16.1326 21.5 16 21.5C15.8674 21.5 15.7402 21.4473 15.6465 21.3536C15.5527 21.2598 15.5 21.1326 15.5 21V16.5H11C10.8674 16.5 10.7402 16.4473 10.6465 16.3536C10.5527 16.2598 10.5 16.1326 10.5 16C10.5 15.8674 10.5527 15.7402 10.6465 15.6464C10.7402 15.5527 10.8674 15.5 11 15.5H15.5V11C15.5 10.8674 15.5527 10.7402 15.6465 10.6464C15.7402 10.5527 15.8674 10.5 16 10.5C16.1326 10.5 16.2598 10.5527 16.3536 10.6464C16.4473 10.7402 16.5 10.8674 16.5 11V15.5H21C21.1326 15.5 21.2598 15.5527 21.3536 15.6464C21.4473 15.7402 21.5 15.8674 21.5 16Z"
                fill="#20409B" />
            </svg>

            <div class="text-black">
              {{ $t("Tạo chữ ký") }}
            </div>
          </div>
        </div>
        <div v-for="(signature, index) in signatures" :key="index" class="signature-item cs-image-container relative">
          <!-- Delete Icon -->
          <div class="absolute top-2 right-2">
            <el-tooltip class="item" effect="dark" content="Xoá chữ ký" placement="bottom">
              <el-button icon="el-icon-delete" circle @click="deleteSignature(signature.id)"></el-button>
            </el-tooltip>
          </div>
          <img class="cs-image" v-if="signature.signature_base64"
            :src="generateImageSrcBase64(signature.signature_base64)" />
        </div>
        <!-- <div v-if="isCreate" ref="CreateSignature">
        <div class="flex flex-col justify-center p-4">
          <div id="signature-pad">
            <canvas id="signature-canvas" width="1000" height="600"></canvas>
          </div>
          <div class="flex gap-2 justify-end mt-2">
            <el-button
              plain
              type="primary"
              @click="
                () => {
                  isCreate = false;
                  clearSignature();
                }
              "
              >{{ $t("Huỷ") }}</el-button
            >
            <el-button plain type="primary" @click="clearSignature()">{{
              $t("Xoá chữ ký")
            }}</el-button>
            <el-button type="primary" @click="saveSignature()">{{
              $t("Tạo chữ ký")
            }}</el-button>
          </div>
        </div>
      </div> -->
      </div>
    </div>
    <ModalCreateSignature ref="ModalCreateSignature" @onSuccess="getDoctorSignatures" />
    <ModalLoginIntrustCA ref="ModalLoginIntrustCA" @onSuccess="handleLoginIntrustCASuccess" />
    <ModalSelectCertType ref="ModalSelectCertType" @onTypeSelected="handleCertTypeSelected" />
    <ModalRegisterIntrustCACert ref="ModalRegisterIntrustCACert" :certType="selectedCertType" @onSuccess="handleRegisterSuccess" />
  </div>
</template>

<script>
import appUtils from '@/utils/appUtils'
import { mapState } from 'vuex'
import SignatureRequest from '../../api/request/SignatureRequest'
import ModalCreateSignature from './ModalCreateSignature.vue'
import ModalLoginIntrustCA from './ModalLoginIntrustCA.vue'
import ModalSelectCertType from './ModalSelectCertType.vue'
import ModalRegisterIntrustCACert from './ModalRegisterIntrustCACert.vue'

export default {
  components: { ModalCreateSignature, ModalLoginIntrustCA, ModalSelectCertType, ModalRegisterIntrustCACert },
  name: 'DoctorSignature',
  data () {
    return {
      signatures: [],
      isLoading: false,
      isCreate: false,
      requestedFeaturesInfo: [],
      appUtils,
      // IntrustCA
      currentIntrustCAAccount: [],
      isLoadingCertificates: false,
      selectedCertType: 'personal',
      intrustCARegistration: null,
      isLoadingRegistration: false
    }
  },
  computed: {
    ...mapState({
      signatureTokenInfo: state => state.app.signatureTokenInfo
    }),
    hodoSign () {
      return this.requestedFeaturesInfo.find(_ => _.key == 'hodo_sign')
    },
    vnptSign () {
      return this.requestedFeaturesInfo.find(_ => _.key == 'vnpt_smart_ca')
    },
    intrustSign () {
      return this.requestedFeaturesInfo.find(_ => _.key == 'intrust_ca')
    }
  },
  async mounted () {
    await Promise.allSettled([
      this.getRequestedFeature(),
      this.getDoctorSignatures()
    ])
    this.getIntrustCARegistration()
    // Get List Cert IntrustCA
    if (this.intrustSign) {
      this.getIntrustCACertList()
    }
  },
  methods: {
    //  Register using signature
    // IntrustCA
    // Get Cert List
    async unlinkIntrustCA () {
      // Ask user to confirm unlinking the IntrustCA account
      try {
        await this.$confirm(
          this.$t('Bạn có chắc chắn muốn gỡ liên kết tài khoản IntrustCA?'),
          this.$t('Gỡ liên kết IntrustCA')
        )
      } catch (err) {
        // Element UI's $confirm rejects when cancelled/closed. Ignore and stop.
        return
      }

      try {
        this.isLoading = true
        const request = new SignatureRequest()
        const response = await request.unlinkIntrustCAAccount()
        console.log('🚀 ~ unlinkIntrustCA:', response)
        if (response.status == 200 && response.data.success == true) {
          this.currentIntrustCAAccount = []
          this.$message({
            type: 'success',
            message: 'Gỡ liên kết tài khoản IntrustCA thành công!'
          })
          // Refresh data after unlink
          this.getRequestedFeature()
          this.getDoctorSignatures()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async getIntrustCACertList () {
      this.isLoadingCertificates = true
      const request = new SignatureRequest()
      const listCer = await request.getIntrustCertificates()
      console.log('🚀 ~ listCer:', listCer)
      if (listCer.status == 200 && listCer.data.success == true) {
        this.currentIntrustCAAccount = listCer.data.data || []
      }
      this.isLoadingCertificates = false
    },
    async getIntrustCARegistration () {
      try {
        this.isLoadingRegistration = true
        const request = new SignatureRequest()
        const response = await request.getIntrustCARegistration()
        console.log('🚀 ~ getIntrustCARegistration:', response)
        if (response.status == 200 && response.data.success == true) {
          this.intrustCARegistration = response.data.data || null
        }
      } catch (error) {
        console.log('Error getIntrustCARegistration:', error)
      } finally {
        this.isLoadingRegistration = false
      }
    },
    registerIntrustCACert () {
      this.$refs.ModalSelectCertType.handleOpen()
    },
    editIntrustCACert () {
      if (this.intrustCARegistration) {
        this.selectedCertType = this.intrustCARegistration.cert_type || 'personal'
        this.$refs.ModalRegisterIntrustCACert.handleOpen(this.intrustCARegistration)
      }
    },
    handleCertTypeSelected (type) {
      this.selectedCertType = type
      this.$refs.ModalRegisterIntrustCACert.handleOpen()
    },
    handleRegisterSuccess (data) {
      this.$message({ type: 'success', message: 'Yêu cầu đăng ký chữ ký số đã được gửi thành công' })
      // Refresh cert list and registration data after registration
      this.getIntrustCACertList()
      this.getIntrustCARegistration()
    },
    async loginIntrustCASignature () {
      this.$refs.ModalLoginIntrustCA.handleOpen()
    },
    async unLinkIntrustCA () {
      this.$refs.ModalLoginIntrustCA.handleOpen()
    },
    handleLoginIntrustCASuccess (data) {
      console.log('IntrustCA login success:', data)
      // Refresh data after successful login
      this.getRequestedFeature()
      this.getDoctorSignatures()
      this.$message({
        type: 'success',
        message: 'Đăng nhập IntrustCA thành công!'
      })
      // Set List Cert
      this.getIntrustCACertList()
    },
    // hodo_sign, vnpt_smart_ca
    async registerSignature (provider) {
      if (provider == 'vnpt_smart_ca' && this.$user.doctor.national_id == '') {
        this.$message({
          showClose: true,
          message: 'Vui lòng cập nhật số thẻ Căn cước công dân (CCCD)',
          type: 'warning'
        })
        return
      }

      this.$rf
        .getRequest('DoctorRequest')
        .requestFeature({
          service_key: provider,
          register_objective: 'user_id',
          value_objective_id: this.$user.id
        })
        .then(r => {
          if (r.code == 200) {
            this.getRequestedFeature()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getDoctorSignatures () {
      try {
        this.isLoading = true
        const request = new SignatureRequest()
        const params = {
          crypto_service_id: this.signatureTokenInfo?.id || 1
        }
        const response = await request.getDoctorSignatures(params)
        this.signatures = response.data || []
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async getRequestedFeature (id) {
      try {
        this.$rf
          .getRequest('DoctorRequest')
          .getRequestFeature({
            service_key: 'hodo_sign,vnpt_smart_ca,intrust_ca',
            user_id: this.$user.id
          })
          .then(res => {
            if (res.code == 200) {
              this.requestedFeaturesInfo = res.data.features
            }
          })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    getRegistrationStatusLabel (status) {
      const statusMap = {
        'PROGRESSING': 'Đang xử lý',
        'NEED_INFO': 'Cần bổ sung thông tin',
        'SUBMITTED': 'Đã gửi',
        'APPROVED': 'Đã duyệt'
      }
      return statusMap[status] || status
    },
    getRegistrationStatusColor (status) {
      const colorMap = {
        'PROGRESSING': 'text-yellow-800 bg-yellow-100',
        'NEED_INFO': 'text-red-800 bg-red-100',
        'SUBMITTED': 'text-blue-800 bg-blue-100',
        'APPROVED': 'text-green-800 bg-green-100'
      }
      return colorMap[status] || 'text-gray-800 bg-gray-100'
    },
    generateImageSrcBase64 (content) {
      var prefix = 'data:image/png;base64,'

      return prefix + content
    },
    async deleteSignature (id) {
      const r = await this.$confirm(
        this.$t('Bạn có chắc chắn muốn xoá chữ ký này?'),
        this.$t('Xoá chữ ký')
      )

      if (!r) return
      try {
        this.isLoading = true
        const request = new SignatureRequest()
        const response = await request.deleteSignature(id)
        if (response.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('Xoá chữ ký thành công')
          })
          this.getDoctorSignatures()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    openModalCreateSignature () {
      this.$refs.ModalCreateSignature.handleOpen(this.$user?.id)
    },
    async handleSaveDrawImage (imageBase64) {
      try {
        this.isLoading = true
        const cleanedBase64String = this.removePrefix(imageBase64)
        const workerName =
          'worker' + window.moment().unix() + 'U' + this.$user.id

        const params = {
          properties: {
            name: workerName,
            DEFAULTKEY: this.signatureTokenInfo?.default_key || process.env.VUE_APP_SIGNATURE_DEFAULT_KEY,
            CRYPTOTOKEN: this.signatureTokenInfo?.worker_name || process.env.VUE_APP_SIGNATURE_CRYPTO_TOKEN,
            TYPE: 'PROCESSABLE',
            ADD_VISIBLE_SIGNATURE: 'True',
            DIGESTALGORITHM: 'SHA256',
            IMPLEMENTATION_CLASS: 'org.signserver.module.pdfsigner.PDFSigner',
            AUTHTYPE: 'NOAUTH',
            DISABLEKEYUSAGECOUNTER: 'false',
            ALLOW_PROPERTY_OVERRIDE:
              'VISIBLE_SIGNATURE_RECTANGLE,VISIBLE_SIGNATURE_PAGE,LOCATION,REASON,description,CERTIFICATION_LEVEL',
            VISIBLE_SIGNATURE_CUSTOM_IMAGE_BASE64: cleanedBase64String,
            user_id: this.$user?.id,
            person_id: this.personID,
            signature_crypto_service_id: this.signatureTokenInfo?.id || 1
          }
        }

        const request = new SignatureRequest()

        const response = await request.createSignature(params)

        if (response.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('Tạo chữ kí thành công')
          })
          this.getDoctorSignatures()
          this.clearSignature()
          this.isCreate = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    toBinary (string) {
      const codeUnits = new Uint16Array(string.length)
      for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = string.charCodeAt(i)
      }
      return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)))
    },
    removePrefix (base64String) {
      let prefix = 'data:image/png;base64,'
      if (base64String.startsWith(prefix)) {
        return base64String.slice(prefix.length)
      }
      return base64String
    },
    getDrawingSignature () {
      let canvas = document.getElementById('signature-canvas')
      let ctx = canvas.getContext('2d')
      let isDrawing = false
      let lastX = 0
      let lastY = 0

      canvas.addEventListener('mousedown', startDrawing)
      canvas.addEventListener('mousemove', draw)
      canvas.addEventListener('mouseup', endDrawing)
      canvas.addEventListener('mouseout', endDrawing)

      canvas.addEventListener('touchstart', startDrawing)
      canvas.addEventListener('touchmove', draw)
      canvas.addEventListener('touchend', endDrawing)

      function startDrawing (e) {
        isDrawing = true
        let x = e.pageX - canvas.offsetLeft
        let y = e.pageY - canvas.offsetTop;
        [lastX, lastY] = [x, y]
      }

      function draw (e) {
        if (!isDrawing) return
        let x, y
        if (e.type.startsWith('touch')) {
          x = e.touches[0].pageX - canvas.offsetLeft
          y = e.touches[0].pageY - canvas.offsetTop
        } else {
          x = e.pageX - canvas.offsetLeft
          y = e.pageY - canvas.offsetTop
        }

        ctx.beginPath()
        ctx.moveTo(lastX, lastY)
        ctx.lineTo(x, y)
        ctx.strokeStyle = '#0000FF'
        ctx.lineWidth = 3
        ctx.lineCap = 'round'
        ctx.stroke();
        [lastX, lastY] = [x, y]
      }

      function endDrawing () {
        isDrawing = false
      }
    },

    clearSignature () {
      const canvas = document.getElementById('signature-canvas')
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
    },

    saveSignature () {
      let croppedData = this.getCroppedImage()
      this.handleSaveDrawImage(croppedData)
    },
    getCroppedImage () {
      let canvas = document.getElementById('signature-canvas')
      let ctx = canvas.getContext('2d')

      let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      let data = imageData.data

      let minX = canvas.width
      let minY = canvas.height
      let maxX = -1
      let maxY = -1
      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          let index = (y * canvas.width + x) * 4
          if (data[index + 3] > 0) {
            if (x < minX) minX = x
            if (x > maxX) maxX = x
            if (y < minY) minY = y
            if (y > maxY) maxY = y
          }
        }
      }

      let croppedWidth = maxX - minX + 1
      let croppedHeight = maxY - minY + 1
      let croppedCanvas = document.createElement('canvas')
      let croppedCtx = croppedCanvas.getContext('2d')
      croppedCanvas.width = croppedWidth
      croppedCanvas.height = croppedHeight
      croppedCtx.putImageData(imageData, -minX, -minY)

      return croppedCanvas.toDataURL()
    },
    formatDateDMY (date_time) {
      return window.moment(date_time).format('DD/MM/YYYY HH:mm')
    },

    formatIntrustDate (dateString) {
      if (!dateString) return ''
      // try parse format like 20261016163141Z (YYYYMMDDHHmmssZ)
      try {
        const m = window.moment(dateString, 'YYYYMMDDHHmmssZ')
        if (m.isValid()) return m.format('DD/MM/YYYY HH:mm')
      } catch (e) {
        // ignore
      }
      // try generic parse (e.g. '2026-10-16 16:31:41')
      try {
        const m2 = window.moment(dateString)
        if (m2.isValid()) return m2.format('DD/MM/YYYY HH:mm')
      } catch (e) { }
      return dateString
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.cs-image-container {
  cursor: pointer;
  padding: 8px;
  border: 1px dashed #000;
  // width: 300px;
  height: 200px;
}

.signature-item {
  :nth-child(1) {
    visibility: hidden;
    transition: all 0.2s ease-in;
  }

  &:hover {
    :nth-child(1) {
      visibility: visible;
    }
  }
}

.cs-create-signature {
  border: 2px dashed #20409b;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}

#signature-pad {
  border: 1px dashed #000;
}

.cs-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}
</style>
